import { useRecoilState } from "recoil";
import { toastListState } from "../atom/atom";
import { Toast } from "../types/type";

const getRandomId = () => String(new Date().getTime());

export function useToast() {
  const [toastList, setToastList] = useRecoilState(toastListState);

  const removeToast = (toastID: Toast["id"]) =>
    setToastList((prev) => prev.filter((toast) => toast.id !== toastID));

  const fireToast = (toast: Toast) => {
    setToastList((prev) => [...prev, { ...toast, id: getRandomId() }]);
    setTimeout(() => removeToast(toast.id), 600 + (toast.duration ?? 1000));
  };

  return { toastList, fireToast };
}
